import { Action } from 'redux';
import { RbacRoleObjectKey } from '../../../model';

export enum ReduxPermissionActionType {
  SET_PERMISSION = 'SET_PERMISSION',
  CLEAR_PERMISSION = 'CLEAR_PERMISSION',
}

export interface ISetPermissionAction extends Action {
  type: ReduxPermissionActionType.SET_PERMISSION;
  result: {
    studioPrem?: { [studioID: string]: ReadonlyArray<string> };
    gamePerm?: { [gameID: string]: ReadonlyArray<string> };
    envPerm?: { [envID: string]: ReadonlyArray<string> };
  };
}

export interface IClearPermissionAction extends Action {
  type: ReduxPermissionActionType.CLEAR_PERMISSION;
}

export type PermissionAction = ISetPermissionAction | IClearPermissionAction;

export interface IPermissionState {
  readonly studioPrem: {
    readonly [studioID: string]: ReadonlyArray<RbacRoleObjectKey>;
  };
  readonly gamePerm: {
    readonly [gameID: string]: ReadonlyArray<RbacRoleObjectKey>;
  };
  readonly envPerm: {
    readonly [envID: string]: ReadonlyArray<RbacRoleObjectKey>;
  };
}
